import React, { PropsWithChildren, SVGProps } from 'react';

type Props = PropsWithChildren<SVGProps<SVGSVGElement>> & {
  view?: { width: number; height: number };
};
export const Svg = React.forwardRef<SVGSVGElement, Props>(
  ({ view, children, ...props }, ref) => (
    <svg
      ref={ref}
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
      viewBox={view && `0 0 ${view.width} ${view.height}`}
      style={{ display: 'inherit' }}
      {...props}
    >
      {children}
    </svg>
  ),
);
